import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "details-form__item" }

import {useStore} from 'vuex';
    import {ref, inject, computed, onMounted, onBeforeMount} from 'vue';
    import {useRouter} from 'vue-router';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import DailyRateSide from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/DailyRateSide.vue';
    import PriceSelectionStrategy from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/PriceSelectionStrategy.vue';
    import PriceSelectionFreelancer from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/PriceSelectionFreelancer.vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DailyRateStep',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {$pageContext, $features} = useGlobalProperties();

    const creationFormValidation = inject(DI.creationFormValidation);
    const trackingRepository = inject(DI.trackingRepository);
    const creationForm = ref(store.getters[getters.creationForm]);

    const isRegular = computed(() => !store.state.isFunnelStrategy);
    const isStepValid = computed(() => creationFormValidation!.isPriceValid(creationForm.value.price, store.getters[getters.priceConfiguration]));

    onBeforeMount(() => {
        store.commit(mutations.definePriceConfiguration, {
            maxPriceAllowed: $pageContext.mandatoryDetails.maxPriceAllowed || 5000,
            minPriceAllowed:
                $features.profileCreationRecommendedFreelancerRate250 === true ? 250 : $pageContext.mandatoryDetails.minPriceAllowed || 25,
        });
    });

    onMounted(() => {
        window.scrollTo({
            top: 0,
        });
        if (window.hj) {
            // Custom event Hotjar
            window.hj('event', 'profile_creation_details_page');
        }
    });

    function goNext(): void {
        trackingRepository!.track(`price-chosen-${store.state.funnelMode}`, {
            price: creationForm.value.price,
        });
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": isStepValid.value,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (isRegular.value)
          ? (_openBlock(), _createBlock(PriceSelectionFreelancer, { key: 0 }))
          : (_openBlock(), _createBlock(PriceSelectionStrategy, { key: 1 }))
      ])
    ]),
    "step-side": _withCtx(() => [
      _createVNode(DailyRateSide, { "is-regular": isRegular.value }, null, 8, ["is-regular"])
    ]),
    _: 1
  }, 8, ["is-step-valid"]))
}
}

})